// extracted by mini-css-extract-plugin
export var blink = "_9h-2";
export var cursor = "_9h-1";
export var reactMarkdown = "_9h-3";
export var streamingText = "_9h-0";